import styled from 'styled-components';
import { PlayBadge } from '../../ui-components/PlayBadge/PlayBadge';

export const Badge = styled(PlayBadge)`
    position: absolute;
    top: 2px;
    left: 2px;
`;
